module.exports = __webpack_public_path__ + "static/media/gluten-free2.920e9801.png";